import { FormattedMessage as FM } from "react-intl";

import { cn } from "tools/ui";
import SetupStepMarker from "./SetupStepMarker";
import { STYLE_ACTION_BUTTON, STYLE_ACTION_BUTTON_PRIMARY } from "../constants";

function SetupStep({ step, number, isNext, qrPrinted, onQrPrinted, onOpen }) {
  return (
    <li className="flex flex-col gap-3 py-3 sm:flex-row sm:items-center">
      <div className="flex min-w-0 flex-1 items-start gap-3">
        <SetupStepMarker done={step.done} number={number} />
        <div className="min-w-0">
          <p className="font-medium text-neutral-800">
            <FM id={step.title} />
          </p>
          <p className="text-sm text-neutral-500">
            <FM id={step.hint} />
          </p>
          {step.manual && (
            <label className="mt-1 flex items-center gap-2 text-sm text-neutral-700">
              <input
                type="checkbox"
                checked={qrPrinted}
                onChange={onQrPrinted}
                className="size-4"
              />
              <FM id="melhous.dash.setup.qr_printed" />
            </label>
          )}
        </div>
      </div>
      <button
        type="button"
        onClick={() => onOpen(step.view)}
        className={cn(
          isNext ? STYLE_ACTION_BUTTON_PRIMARY : STYLE_ACTION_BUTTON,
          "shrink-0",
        )}
      >
        <FM id={step.action} />
      </button>
    </li>
  );
}

export default SetupStep;
